import { ColDef, SelectionChangedEvent } from "@ag-grid-community/core";

export interface GroupOverviewProps {
  groupId: string;
  groupData?: any;
  loading?: boolean;
}

export interface GroupData {
  id: string;
  name: string;
  groupId: string;
  source: string;
  lastSync: string;
  lastModified: string;
  modifiedBy: string;
  createdAt: string;
  createdBy: string;
  numberOfUsers: number;
  services: Array<{
    id: string;
    name: string;
    roles: number;
    icon?: string;
  }>;
}

export enum Source {
  PLATFORM = 'PLATFORM',
  SCIM = 'SCIM'
}

export interface RoleRow {
  id: string;
  roleName: string;
  source_account_friendly_identifier: string;
}

export interface ServiceData {
  account: string;
  sp_account_id: string;
  sp_account_friendly_name: string;
  roles: RoleRow[];
}

export interface AssignedRole {
  serviceLabel: string;
  account: string;
  roleName: string;
  serviceKey: string;
  roleId: string;
  applicationId: string;
  serviceProviderAccountId?: string;
}

export interface GroupAccessDrawerProps {
  open: boolean;
  onClose: () => void;
  groupName: string;
  availableServices: { value: string; label: string; disabled?: boolean }[];
  selectedServices: string[];
  setSelectedServices: (values: any) => void;
  serviceRoleData: Record<string, ServiceData>;
  selectedRoles: Record<string, string[]>;
  setSelectedRoles: (v: Record<string, string[]>) => void;
  assignedRolesList: AssignedRole[];
  removeAssignedRole: (serviceKey: string, roleId: string) => void;
  handleAssignAccess: () => void;
  handleCancel: () => void;
  hasExistingRoles: boolean;
}

export interface GroupAccessProps {
  groupId: string;
  groupData?: any;
  loading?: boolean;
  onRefresh?: () => void;
}

export interface GroupAccessData {
  id: string;
  service: string;
  account: string;
  accountId?: string;
  role: string;
  assignedBy: string;
  assignedOn: string;
}

export interface RoleRow {
  id: string;
  roleName: string;
  applicationId?: string;
  serviceProviderAccountId?: string;
}
